import { v4 as uuidv4 } from 'uuid'
const uuidTimeout = 1000 * 60 * 5
export function generateUUIDv4() {
	return uuidv4().replace(/-/g, '')
}

export function refreshUUIDClient(app) {
    const newUUID = generateUUIDv4()
    app.$cookies.set('track_uuid', newUUID)
    refreshTrackTime(app)
    return newUUID
}

export function checkUUIDClient(app) {
    const currentCookie = app.$cookies.get('track_uuid')
	const timestamp = app.$cookies.get('track_time')
	const isValid
    = timestamp && Date.now() - Number.parseInt(timestamp) < uuidTimeout
    if (!isValid || !currentCookie) {
        return refreshUUIDClient(app)
    } else {
        return currentCookie
    }
}

export function refreshTrackTime(app) {
    const newTimestamp = Date.now()
    app.$cookies.set('track_time', newTimestamp)
}